export default __webpack_public_path__ + "../img/9e1b647243d5d01aa754ae0c439baa79.png";